import { withMotionMax } from '@hoc/withMotionMax';
import { AnimatePresence } from 'framer-motion';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import CountdownBanner from './Components/CountdownBanner/CountdownBanner';
import ImageBanner from './Components/ImageBanner/ImageBanner';
import VideoBanner from './Components/VideoBanner/VideoBanner';
import S from './MessageBanner.styles';
export var MessageBannerType;
(function (MessageBannerType) {
    MessageBannerType[MessageBannerType["Countdown"] = 0] = "Countdown";
    MessageBannerType[MessageBannerType["Image"] = 1] = "Image";
    MessageBannerType[MessageBannerType["Video"] = 2] = "Video";
})(MessageBannerType || (MessageBannerType = {}));
const MessageBanner = (props) => {
    const [currentItemIndex, setCurrentItemIndex] = React.useState(0);
    if (!props.items || !props.items.length) {
        return null;
    }
    return (React.createElement(S.Wrapper, null,
        React.createElement(S.GlobalStyles, null),
        React.createElement(AnimatePresence, null, props.items.map((item, index) => {
            if (index !== currentItemIndex) {
                return null;
            }
            return (React.createElement(S.Container, { key: `message-banner-${index}`, initial: { opacity: 0, y: `-105%` }, animate: { opacity: 1, y: 0 }, exit: { opacity: 0, y: `105%` }, transition: { duration: 0.45 }, ...(item.backgroundColorHex || item.foregroundColorHex
                    ? {
                        style: {
                            '--bgColor': item.backgroundColorHex,
                            '--fgColor': item.foregroundColorHex,
                        },
                    }
                    : {}) },
                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                    React.createElement(S.Inner, { ...(item.type !== MessageBannerType.Countdown && item.cta
                            ? {
                                as: 'a',
                                href: item.cta?.url,
                                title: item.cta?.text,
                                target: item.cta?.target,
                            }
                            : {}), "data-is-link": !!item.cta }, renderBannerType(item)))));
        }))));
    function renderBannerType(item) {
        switch (item.type) {
            case MessageBannerType.Countdown:
                return (React.createElement(CountdownBanner, { text: item.text, countdownEndDate: item.countdownEndDate, countdownUrl: item.countdownUrl, cta: item.cta, images: item.images, videos: item.videos, currentIndex: currentItemIndex, maxIndex: props.items.length - 1, onTimerEnd: (nextIndex) => setCurrentItemIndex(nextIndex) }));
            case MessageBannerType.Image:
                return React.createElement(ImageBanner, { images: item.images });
            case MessageBannerType.Video:
                return React.createElement(VideoBanner, { images: item.images, videos: item.videos });
            default:
                return null;
        }
    }
};
export default withMotionMax(MessageBanner);
